import { useCallback } from 'react';
import type { ViewStyle } from 'react-native';
import { interpolate, useAnimatedStyle, useSharedValue, withTiming, type AnimatedStyle } from 'react-native-reanimated';
import Dimens from 'src/core/utils/Dimens';

interface PressFeedback {
	style: AnimatedStyle<ViewStyle>;
	onPressIn: () => void;
	onPressOut: () => void;
}

// Keep this off the view that carries the entrance animation: two animated styles both writing opacity cancel out.
export function usePressFeedback(): PressFeedback {
	const pressed = useSharedValue(0);

	const onPressIn = useCallback(() => {
		pressed.value = 1;
	}, [pressed]);

	const onPressOut = useCallback(() => {
		pressed.value = withTiming(0, { duration: Dimens.animationDuration100 });
	}, [pressed]);

	const style = useAnimatedStyle(() => ({
		opacity: interpolate(pressed.value, [0, 1], [Dimens.opacity100, Dimens.opacity80]),
	}));

	return { style, onPressIn, onPressOut };
}
